module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_bzcrcc@2x.dbf8cf7c.png";